export default defineNuxtPlugin(() => {
  // 客户端全局错误捕获
  const handleError = (error: Error, type: string, context?: any) => {
    console.error(`🚨 [CLIENT] ${type}错误:`, {
      message: error.message,
      stack: error.stack,
      name: error.name,
      type,
      context,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });

    // 可以在这里添加错误上报逻辑
    // 例如发送到监控服务
    if (process.env.NODE_ENV === 'production') {
      // 发送错误到监控服务
      // errorReportingService.report(error, { type, context })
    }
  };

  // Vue错误处理
  const vueApp = getCurrentInstance()?.appContext?.app;
  if (vueApp) {
    vueApp.config.errorHandler = (error: Error, instance, info: string) => {
      handleError(error, 'Vue组件错误', { info, componentName: instance?.$options?.name });
    };

    vueApp.config.warnHandler = (msg: string, instance, trace: string) => {
      console.warn('⚠️ [CLIENT] Vue警告:', {
        message: msg,
        trace,
        componentName: instance?.$options?.name,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      });
    };
  }

  // 全局未捕获错误
  window.addEventListener('error', event => {
    handleError(event.error || new Error(event.message), '全局JavaScript错误', {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  // Promise拒绝错误
  window.addEventListener('unhandledrejection', event => {
    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));

    handleError(error, '未处理的Promise拒绝', {
      reason: event.reason,
      promise: event.promise,
    });
  });

  // 资源加载错误
  window.addEventListener(
    'error',
    event => {
      if (event.target !== window) {
        const target = event.target as HTMLElement;
        handleError(new Error(`资源加载失败: ${target.tagName}`), '资源加载错误', {
          tagName: target.tagName,
          src: (target as HTMLImageElement).src || (target as HTMLLinkElement).href,
          type: target.getAttribute('type'),
        });
      }
    },
    true
  );

  // 网络错误监控
  if ('fetch' in window) {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);

        // 记录失败的请求
        if (!response.ok) {
          console.error('🌐 [CLIENT] 网络请求失败:', {
            url: args[0],
            status: response.status,
            statusText: response.statusText,
            method: args[1]?.method || 'GET',
            timestamp: new Date().toISOString(),
          });
        }

        return response;
      } catch (error) {
        console.error('🌐 [CLIENT] 网络请求异常:', {
          url: args[0],
          method: args[1]?.method || 'GET',
          error: error instanceof Error ? error.message : String(error),
          timestamp: new Date().toISOString(),
        });
        throw error;
      }
    };
  }

  // 提供错误报告方法
  return {
    provide: {
      reportError: (error: Error, context?: any) => {
        handleError(error, '手动报告错误', context);
      },
    },
  };
});
